import { StyledProps, React, withStyles, Fragment} from '@api';
import { LinearProgress, CircularProgress } from '@material-ui/core';

const styles = theme => ({
  colorPrimary:{
    backgroundColor:"#add8e6",
    height: "6px",
    zIndex: "1"
  },
  colorSecondary:{
    backgroundColor:"#4183F3",

  }
})
interface IDeterminateProgressBarProps extends StyledProps {
progressBarType: "circular" | "linear",
percentage?: number,
showProgressBar:boolean
width?: number
}

const DeterminateProgressBarRaw =(props:IDeterminateProgressBarProps)=> {
const {classes:{colorPrimary,colorSecondary}}=props
  const renderLinearProgressBar=<LinearProgress 
    classes={{
      colorPrimary : colorPrimary,
      barColorPrimary: colorSecondary
    }}
    variant="determinate"
    value={props.percentage}/>

   const renderCircularProgressBar=<CircularProgress
    classes={{
      colorPrimary : colorPrimary,
      colorSecondary: colorSecondary
    }}
    variant="determinate"
    value={props.percentage}
  />
  
  return (<div style={{height:"6px" , width:(props.width || '100%'),backgroundColor: "#f5f5f5"}}>
      {props.showProgressBar && props.percentage > 0 && props.percentage <= 100 ?
       ( 
         props.progressBarType==="linear" ?
         renderLinearProgressBar : renderCircularProgressBar
     )
                                                                                : <Fragment></Fragment>
    }
  </div> )
  }

export const DeterminateProgressBar : any = withStyles(styles as any)(DeterminateProgressBarRaw)


// WEBPACK FOOTER //
// ./src/modules/common/components/DeterminateProgressBar.tsx